import * as Actions from '../constant/ActionTypes';

const listDevicesPerSiteReducer = (devicesPerSite={}, action) => {
    switch(action.type) {
        case Actions.LIST_DEVICES_PER_SITE:
            return action.payload;
            
        default :
        return devicesPerSite;
    }
}
export default listDevicesPerSiteReducer;